import {
  TransferItemAPITypes,
  TransferItemUITypes,
} from '@app/constant/transfer-item-types';

const createBareTree = (name) => ({
  uiType: TransferItemUITypes.directory,
  name,
  map: {},
  items: [],
});

const addBranchToTree = (tree, branch, item) => {
  const nodeName = branch.shift();

  if (branch.length) {
    let subTree = tree.map[nodeName];

    if (!subTree) {
      subTree = createBareTree(nodeName);
      tree.map[nodeName] = subTree;
      tree.items.push(subTree);
    }

    addBranchToTree(subTree, branch, item);
  } else {
    tree.map[nodeName] = item;
    tree.items.push(item);
  }
};

const getSubNodesFromItemName = (itemName) => {
  /**
   * Forward slash is always used as a separator
   * Also it is not possible to have it as a part of file-system-entry name
   */
  return itemName.split('/');
};

const getItemsWithUITypes = (items = []) =>
  items.map((item) => ({
    ...item,
    uiType:
      item.apiType === TransferItemAPITypes.empty_directory
        ? TransferItemUITypes.directory
        : TransferItemUITypes.file,
  }));

const buildItemsTree = (items = []) => {
  const tree = createBareTree('/');

  items.forEach((item) => {
    const branch = getSubNodesFromItemName(item.name);
    addBranchToTree(tree, branch, item);
  });

  return tree;
};

export { getItemsWithUITypes, buildItemsTree, getSubNodesFromItemName };
